import { getStoredInstance } from '../components/authentication/initialization.helpers';
export class GlobalVariables {
  private static instance: GlobalVariables | null = null;
  public integrationMode = 'web';
  public variables: any = {};

  static getInstance(): GlobalVariables {
    if (GlobalVariables.instance === null) {
      GlobalVariables.instance = new GlobalVariables();
    }
    return GlobalVariables.instance;
  }
  public setIntegrationMode(mode: string) {
    const app_configuration = this.getApplicationConfiguration();
    if (app_configuration) {
      app_configuration.integrationMode = mode;
      localStorage.setItem('app_configuration', JSON.stringify(app_configuration));
    } else {
      localStorage.setItem('app_configuration', JSON.stringify({ integrationMode: mode }));
    }
  }

  public set(key: string, value: any) {
    this.variables[key] = value;
  }

  public get(key: string) {
    try {
      return this.variables[key];
    } catch (e) {
      return null;
    }
  }

  public del(key: string) {
    try {
      delete this.variables[key];
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  }

  private getApplicationConfiguration() {
    const app_configuration = localStorage.getItem('app_configuration');
    if (app_configuration) {
      const app_configuration_json = JSON.parse(app_configuration);
      return app_configuration_json;
    }
    return null;
  }

  public getIntegrationMode() {
    const app_configuration = this.getApplicationConfiguration();

    if (app_configuration) {
      return app_configuration.integrationMode;
    }
    return null;
  }
}

const backendInstance = getStoredInstance();

interface Config {
  REACT_APP_ID: string;
  REACT_APP_CLIENT: string;
  REACT_APP_URL_BACKEND_API: string;
  REACT_APP_API_VERSION: string;
  REACT_APP_URL_BACKEND_API_WS: string;
  REACT_APP_BASE_URL: string;
  COOKIE_SESSION_EXPIRY_NAME: string;
  REACT_APP_NAME?: string;
}

export const configTemplate: Config = {
  REACT_APP_ID: import.meta.env.VITE_ID as string,
  REACT_APP_CLIENT: 'sbrain-web',
  // VITE_FALLBACK_URL is not defined in any .env; without the second fallback
  // an empty `backend_instance` leaves baseURL undefined, so every API call
  // resolves against the web origin and the dev server answers 200 text/html.
  REACT_APP_URL_BACKEND_API:
    backendInstance ||
    (import.meta.env.VITE_FALLBACK_URL as string) ||
    (import.meta.env.VITE_URL_BACKEND_API as string),
  REACT_APP_API_VERSION: 'v1',
  REACT_APP_URL_BACKEND_API_WS: import.meta.env.VITE_WSS_URL as string,
  REACT_APP_BASE_URL: import.meta.env.VITE_BASE_URL as string,
  COOKIE_SESSION_EXPIRY_NAME: 'session-expiry',
  REACT_APP_NAME: import.meta.env.VITE_NAME as string,
};

export const config: Config = configTemplate;
